import React from "react";
import ComponenteConItemsForm from "./ComponenteConItemsForm";

export default function AccesorioForm() {
  return <ComponenteConItemsForm titulo="Accesorio" tipo="accesorio" />;
}
